<template>
  <div>
    <h3>Assign Subhire</h3>
    <InputText 
      v-model="assetName" 
      placeholder="Asset Name" 
      class="w-full mb-4"
    />
    <InputNumber 
      v-model="quantity" 
      placeholder="Quantity" 
      :min="1"
      class="w-full mb-4"
    />
    <InputNumber 
      v-model="price" 
      placeholder="Price per day" 
      :min="0"
      mode="currency"
      currency="GBP"
      class="w-full mb-4"
    />
    <InputNumber 
      v-model="days" 
      placeholder="Days" 
      :min="1"
      class="w-full mb-4"
    />
    <Button 
      label="Save" 
      :loading="isSubmitting" 
      :disabled="!assetName.trim() || !quantity || !price || !days"
      @click="saveAsset"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { addEquipmentListContent } from '@/services/projectService';
import { projectStore } from "../projectStore";
import { useToastService } from '@/composables/useToastService';

// Toast service
const toast = useToastService();

const assetName = ref("");
const quantity = ref(1);
const price = ref(0);
const days = ref(1);
const isSubmitting = ref(false);

const saveAsset = async () => {
    if (!assetName.value.trim() || !quantity.value || !price.value || !days.value) {
        return;
    }

    isSubmitting.value = true;

    try {
        const projectId = projectStore.currentProjectId;
        const equipmentListId = projectStore.currentEquipmentListId;
        const parentGroupId = projectStore.currentDraggableItemId;
        
        if (!projectId || !equipmentListId) {
            throw new Error('Project ID or Equipment List ID not found');
        }

        const contentData = {
            type: "item",
            name: assetName.value.trim(),
            asset_type: "subhire",
            quantity: quantity.value,
            days: days.value,
            price: price.value,
            discount: 0,
            notes: "",
            parent_id: parentGroupId ? parseInt(parentGroupId) : null
        };

        await addEquipmentListContent(projectId, equipmentListId, contentData);

        // Refresh the equipment list content to show the new subhire
        if (projectStore.refreshFunction && typeof projectStore.refreshFunction === 'function') {
            await projectStore.refreshFunction();
        }

        // Close the modal first
        projectStore.isModalVisible = false;

        // Show success toast
        toast.add({
            severity: 'success',
            summary: 'Subhire Added',
            detail: `Subhire "${assetName.value}" added successfully`,
            life: 3000
        });

    } catch (error) {
        console.error('[AddSubhiresModal] Error adding subhire:', error);
        
        // Show error toast
        toast.add({
            severity: 'error',
            summary: 'Error',
            detail: `Failed to add subhire: ${error.message}`,
            life: 3000
        });
    } finally {
        isSubmitting.value = false;
    }
};
</script>

<style scoped>
/* Add your styles if needed */
</style>
